export default {"src":"/_next/static/media/CrossWhite.4db8608d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};